import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

function DataTable({ tableHeaders, tableData, searchData }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  console.log("The recived data ", tableData);
  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="a dense table"
          className="table"
        >
          <TableHead style={{ backgroundColor: "#f3f7f7" }}>
            <TableRow>
              {tableHeaders.map((headers) => (
                <TableCell>{headers}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {tableData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .filter((item) => {
                console.log("The search results is " + item._id);
                if (searchData === " ") {
                  console.log("if" + item);
                  return item;
                } else if (
                  item.name?.toLowerCase().includes(searchData.toLowerCase())
                ) {
                  console.log("else" + item);
                  return item;
                }
              })
              .map((row, index) => (
                <TableRow
                  hover
                  key={row._id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="td" scope="row">
                    {100000 + index + 1}
                  </TableCell>
                  <TableCell component="td" scope="row">
                    {row?.name}
                  </TableCell>
                  <TableCell component="td">{row?.email}</TableCell>
                  <TableCell component="td">{row?.phone}</TableCell>
                  <TableCell component="td">{row?.dob}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}

export default DataTable;
